export const isNil = (value: any): boolean => (value === null || value === undefined);
export const isEmpty = (value: any): boolean => (value === '' || value === [] || value === {});
export const isValid = (value: any): boolean => !isNil(value) && !isEmpty(value);
export const convertPrice = (priceString: string): number => parseFloat(priceString);
export const convertDiscountPercentage = (percentageString: string): number => Math.abs(parseFloat(percentageString)/100);
export const getValueIfIsNotNil = (value: any, defaultValue: any = ''): any => !isNil(value) ? value : defaultValue;
